import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "bootstrap";
import "./assets/scss/theme.scss";
import "./assets/css/fontawesome/all.css";
import "./assets/fonts/Feather/feather.css";
import { EventBus } from "./event-bus.js";
import axios from "axios";
import VueAxios from "vue-axios";
import VueGtag from "vue-gtag";
import VueCookies from "vue-cookies";
import Parallax from "vue-parallaxy";
import Vuelidate from "vuelidate";
import "object-fit-images";
import { jarallax, jarallaxVideo } from "jarallax";
import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, {
  siteKey: "6LdSroEaAAAAAPX8_Ndr0OWSZN2a_Y6s3i5phL3b",
  loaderOptions: {
    autoHideBadge: true,
    explicitRenderParameters: true,
    badge: "bottomleft",
  },
});
Vue.use(VueCookies);

Vue.use(Vuelidate);

Vue.use(VueAxios, axios);
Vue.use(EventBus);

Vue.component("parallax", Parallax);

Vue.$cookies.config("14d");

window.addEventListener("load", function(event) {
  jarallax(document.querySelectorAll(".jarallax"), {
    speed: 0.2,
  });
});

window.API_URL = "https://app.neemanfoundation.com/public/";
// window.API_URL = "http://app.neeman.test/public/";

// Stripe publishable key – set VUE_APP_STRIPE_PK in your .env file (see .env.example)
window.STRIPE_PK = process.env.VUE_APP_STRIPE_PK || "";

Vue.config.productionTip = false;

Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },

  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
store.state.api_url = "https://app.neemanfoundation.com";
// store.state.api_url = "http://app.neeman.test";

Vue.use(VueGtag, {
  config: { id: "G-BFKKB8E9VZ" },
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
